import {
  BenchmarkReportCardExportables,
  BenchmarkReportExportables,
  FileType,
  ReportEntry,
} from 'spw-redux/modules/reports/types';
import {
  BenchmarkProject,
  BenchmarkReportCategoriesMap,
  BenchmarkReportIconsMap,
} from 'spw-redux/modules/benchmark-reports/types';
import { Clip, Report, ReportRequest } from '../../models/Report';

const CARDS_EXPORTABLE_HEADER_HEIGHT_IN_PX = 33;

export default class BenchmarkReportExportable implements Report {
  benchmarkReportId: number;

  exportableType: BenchmarkReportExportables;

  format: FileType;

  isIndividualCardsExport?: boolean;

  selectedBenchmarkProjects: BenchmarkProject[];

  benchmarkReportCategories: BenchmarkReportCategoriesMap;

  benchmarkReportIcons: BenchmarkReportIconsMap;

  constructor({
    format,
    benchmarkReportId,
    isIndividualCardsExport,
    selectedBenchmarkProjects,
    benchmarkReportCategories,
    benchmarkReportIcons,
  }: {
    format: FileType;
    benchmarkReportId: number;
    isIndividualCardsExport?: boolean;
    selectedBenchmarkProjects: BenchmarkProject[];
    benchmarkReportCategories: BenchmarkReportCategoriesMap;
    benchmarkReportIcons: BenchmarkReportIconsMap;
  }) {
    this.benchmarkReportId = benchmarkReportId;
    this.selectedBenchmarkProjects = selectedBenchmarkProjects;
    this.exportableType = BenchmarkReportExportables.summary;
    this.format = format;
    this.isIndividualCardsExport = isIndividualCardsExport;
    this.benchmarkReportCategories = benchmarkReportCategories;
    this.benchmarkReportIcons = benchmarkReportIcons;
  }

  getReportRequest(): ReportRequest {
    let reportEntries: ReportEntry[];
    const linkedProjectsIds = this.selectedBenchmarkProjects
      .filter((bp) => bp.linked)
      .map((bp) => bp.project.id);

    const queryParams = {
      field: 'linked_projects',
      value: JSON.stringify(linkedProjectsIds),
    };

    if (!this.isIndividualCardsExport)
      reportEntries = [
        {
          exportable: this.exportableType,
          queryParams,
          screenshotsOpts: [
            {
              format: this.format.toUpperCase(),
              width: 1440,
              localStorageItems: [
                {
                  name: 'reportCategories',
                  value: JSON.stringify(this.benchmarkReportCategories),
                },
                {
                  name: 'reportIcons',
                  value: JSON.stringify(this.benchmarkReportIcons),
                },
              ],
            },
          ],
        },
      ];
    if (this.format === 'png' && this.isIndividualCardsExport)
      reportEntries = [
        {
          cardType: BenchmarkReportCardExportables.reportOverview,
          clip: {
            x: 0,
            y: 0,
            width: 696,
            height: 312 + CARDS_EXPORTABLE_HEADER_HEIGHT_IN_PX,
          },
        },
        {
          cardType: BenchmarkReportCardExportables.individualWorkspacesAnalysis,
          clip: {
            x: 0,
            y: 0,
            width: 696,
            height: 312 + CARDS_EXPORTABLE_HEADER_HEIGHT_IN_PX,
          },
        },
        {
          cardType: BenchmarkReportCardExportables.USFAllocation,
          clip: {
            x: 0,
            y: 0,
            width: 719,
            height: 463 + CARDS_EXPORTABLE_HEADER_HEIGHT_IN_PX,
          },
        },
        {
          cardType: BenchmarkReportCardExportables.workSeatRatios,
          clip: {
            x: 0,
            y: 0,
            width: 696,
            height: 302 + CARDS_EXPORTABLE_HEADER_HEIGHT_IN_PX,
          },
        },
        {
          cardType: BenchmarkReportCardExportables.USFMetrics,
          clip: {
            x: 0,
            y: 0,
            width: 696,
            height: 146 + CARDS_EXPORTABLE_HEADER_HEIGHT_IN_PX,
          },
        },
      ].map(({ cardType, clip }: { cardType: string; clip: Clip }) => {
        return {
          exportable: this.exportableType,
          queryParams,
          variants: {
            cardType,
          },
          screenshotsOpts: [
            {
              format: this.format.toUpperCase(),
              width: 1440,
              clip,
              localStorageItems: [
                {
                  name: 'reportCategories',
                  value: JSON.stringify(this.benchmarkReportCategories),
                },
                {
                  name: 'reportIcons',
                  value: JSON.stringify(this.benchmarkReportIcons),
                },
              ],
            },
          ],
        } as ReportEntry;
      });

    return {
      benchmarkReportId: this.benchmarkReportId,
      reportEntries,
    };
  }
}
